module.exports = __webpack_public_path__ + "img/home-hero-image_large.836b59b5.jpg";